/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type {
  CarouselApi,
  CarouselProps,
  UseCarouselProps,
} from "@packages/ui";
import { Carousel, spacing, useCarousel } from "@packages/ui";

const paddingBottomStyle: Interpolation = {
  paddingBottom: spacing.m,
};
const paddingTopStyle: Interpolation = {
  paddingTop: spacing.m,
};

export type SectionCarouselProps = CarouselProps & {
  size?: CarouselApi["size"];
  apiProps?: Partial<UseCarouselProps>;
};

export const SectionCarousel = ({
  children,
  size,
  apiProps,
  ...props
}: SectionCarouselProps) => {
  const carouselApi = useCarousel({ size, ...apiProps } as UseCarouselProps);

  return (
    <Carousel
      carouselApi={carouselApi}
      containerCSS={[paddingBottomStyle, paddingTopStyle]}
      {...props}
    >
      {children}
    </Carousel>
  );
};
